export default () => `
    id
    org
    companyName
    ndc
    description
    type
`;
